/*******************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2026 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ******************************************************************************/
import { EnhanceV1MixEffect } from "./EnhanceV1MixEffect";
import { EnhanceV2MixEffect } from "./EnhanceV2MixEffect";
import { BackgroundEffect } from "./BackgroundEffect";
import { LongFadeInEffect } from "./LongFadeInEffect";
import { LongFadeOutEffect } from "./LongFadeOutEffect";
import { MicroFadeInEffect } from "./MicroFadeInEffect";
import { MicroFadeOutEffect } from "./MicroFadeOutEffect";
import { AudioEffectClass, URLProvidingEffectClass } from "types/AudioEffect";

export const URL_PROVIDING_AUDIO_EFFECTS: URLProvidingEffectClass[] = [
  EnhanceV2MixEffect,
  EnhanceV1MixEffect,
];

export const AUDIO_EFFECTS: AudioEffectClass[] = [
  BackgroundEffect,
  LongFadeInEffect,
  LongFadeOutEffect,
  MicroFadeInEffect,
  MicroFadeOutEffect,
];
